import { render, staticRenderFns } from "./redbookDialog.vue?vue&type=template&id=045bf7ae&scoped=true&"
import script from "./redbookDialog.vue?vue&type=script&lang=js&"
export * from "./redbookDialog.vue?vue&type=script&lang=js&"
import style0 from "./redbookDialog.vue?vue&type=style&index=0&id=045bf7ae&prod&lang=scss&scoped=true&"
import style1 from "./redbookDialog.vue?vue&type=style&index=1&id=045bf7ae&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045bf7ae",
  null
  
)

export default component.exports